import CityPageTemplate from "../city-template/CityPageTemplate";
import { dearbornConfig } from "./data";

export default function DearbornPage() {
  return <CityPageTemplate config={dearbornConfig} />;
}